import Box from "@/common/components/Box";
import ResumeItem from "@/common/components/ResumeItem";
import { useForwardingTabContext } from "@/features/maintenance/features/workflows/hooks/forwardings/useForwardingTabContext";
import TransportAutoEntriesComplete from "./Transport/AutoEntries/Complete";

interface MaintenanceWorkflowForwardingCheckinEntrySectionProps {
  showTransportAutoEntriesDeliveryCodeWithComplete?: boolean;
}

const MaintenanceWorkflowForwardingCheckinEntrySection = ({
  showTransportAutoEntriesDeliveryCodeWithComplete,
}: MaintenanceWorkflowForwardingCheckinEntrySectionProps) => {
  const { forwarding } = useForwardingTabContext();

  return (
    <Box className="p-4 flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <div className="flex flex-col">
          <p className="text-lg font-semibold">
            Método de check-in
          </p>

          {forwarding?.checkin_entry?.completed_at && (
            <p className="text-valid text-xs">
              Check-in concluído
            </p>
          )}
        </div>

        {showTransportAutoEntriesDeliveryCodeWithComplete && (
          <TransportAutoEntriesComplete
            checkinEntry={forwarding.checkin_entry}
          />
        )}
      </div>

      <div className="flex gap-3">
        {forwarding?.checkin_entry?.responsible && (
          <ResumeItem
            label="Responsável por Transporte"
            value={forwarding?.checkin_entry?.responsible.full_name || '--'}
            className="text-xs"
            valueClassName="font-bold text-sm"
          />
        )}
      </div>
    </Box>
  )
}

export default MaintenanceWorkflowForwardingCheckinEntrySection;
